<template>
  <v-container fluid class="pa-0 d-flex" >
    <v-col class="pa-0 ma-0 print-hide" id="capLeftSection"  >
      <!-- mobile version -->
      <v-row class="d-sm-none icc-code-adop-title-mobile print-hide">
        <v-col class="pa-0 ma-0 mt-4" cols="8">
          <span class="mainPageHeaderSmall pl-4 print-hide">ICC Code Adoptions</span>
        </v-col>
         <v-col class="pa-0 ma-0 text-right" cols="2">
          <span v-on:click="searchBar = !searchBar" class="search-m"><i class="fa fa-search font18" aria-hidden="true"></i></span>
        </v-col>
        <v-col class="pa-0 ma-0 pr-3 pr-md-0 text-right" cols="2">
          <span>
            <Geolocationmarker :isSmallSize="true" ></Geolocationmarker>
          </span>
        </v-col>
      </v-row>
      <div class="clearfix"></div>
      <div class="for-mobiledrop-down print-hide">
        <v-col cols="12" class="d-none d-sm-block px-1">
          <v-flex xs12 class="d-none d-sm-inline body-2">
            <!-- Use the search field below to view the adoptions associated with state, county, jurisdiction or township -->
          </v-flex>
        </v-col>
        <div
          :class="searchInpCnt"
          v-show="!searchBar"
        >
        </div>
      </div>
      <div class="clearfix"></div>
      <v-row class="mb-6 d-block d-sm-none bg-white print-hide">
        <back-button class="mb-2" :navigatedFrom="`Home`"></back-button>
        <v-col :class="boxshadow_white" cols="12">
          <Breadcrumb
            :callOnProfilePage="true"
            :key="$route.fullPath"
            @defaultAdoptionItems="defaultAdoptionItems = $event"
            @dataLoader="dataLoader = $event"
          ></Breadcrumb>
        </v-col>
        <v-col cols="12" :class="boxshadow_white">
          <v-row class="d-flex align-items-center">
            <v-col v-if="responseObject.entitySeal" cols="2">
              <v-img
                :src="
                  responseObject.entitySeal !== undefined &&
                  responseObject.entitySeal
                    ? responseObject.entitySeal
                    : require('@/assets/seal-default.png')
                "
                max-width="72"
                class="img-width"
              />
            </v-col>
            <v-col v-if="responseObject.entitySeal" cols="7">
              <div class="textHeadStateWrapper">
                {{ responseObject.entityName ? responseObject.entityName : "" }}
              </div>
              <div class="font18 mt-2" v-if="responseObject.adoptionLevel === '1'" >
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else-if="responseObject.adoptionLevel === '4'" >
                {{ responseObject.countyName }},
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else >
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
            </v-col>
            <v-col v-else cols="9">
              <div class="textHeadStateWrapper print-hide">
                {{ responseObject.entityName ? responseObject.entityName : "" }}
              </div>
              <div class="font18 mt-2 print-hide" v-if="responseObject.adoptionLevel === '1'" >
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else-if="responseObject.adoptionLevel === '4'" >
                {{ responseObject.countyName }},
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else >
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
            </v-col>
            <v-col
              cols="3"
              v-on:click="seen = !seen"
              v-if="seen"
            >
              <div class="mobileVPLnk print-hide" >View Profile</div>
            </v-col>
            <v-col
              cols="3"
              v-on:click="seen = !seen"
              v-if="!seen"
            >
            <div class="mobileVPLnk" >Hide Profile</div>
            </v-col>
          </v-row>
          <div class="clearfix"></div>
          <v-row v-if="!seen" >
            <v-col
              cols="12"
            >
              <p class="mb-2 text-center" v-if="(responseObject.jurisdictionUrl && responseObject.jurisdictionUrl !== null)">
                <v-btn
                color="#49A942"
                small
                style="color:white;"
                @click="onClickCodeOffice"
                >
                <span v-if="responseObject.adoptionLevel === '1'" >State Information and Resources</span>
                <span v-else >Code Office</span>
                <v-icon class="fa" x-small aria-hidden="true"
                  >mdi-open-in-new</v-icon
                >
                </v-btn>
              </p>
              <p style="width:96% !important;border-top:1px solid #e1e1e1" class="pt-2 for-mobile-profile-txt">
                {{ responseObject.jurisdictionProfile }}
              </p>
              <p class="mb-0 text-center" v-if="(responseObject.amendmentUrl && responseObject.amendmentUrl !== null && responseObject.amendmentUrl !== 'NA')">
                <v-btn
                color="#49A942"
                small
                style="color:white;"
                @click="onClickAmendmentUrl"
                >
                AMENDMENT URL
                <v-icon class="fa" x-small aria-hidden="true"
                  >mdi-open-in-new</v-icon
                >
                </v-btn>
              </p>
            </v-col>
            <v-col cols="12" >
              <!-- Mobile Map start -->
              <v-col class="pr-0 pl-0 pt-0 pb-0">
                <div class="mt-0">
                  <CodeAdoptionMap v-if="responseObject.timeStamp && isMobile" :key="responseObject.timeStamp" />
                </div>
              </v-col>
              <!-- Mobile Map end -->
            </v-col>
            <v-col cols="12" >
              <v-spacer></v-spacer>
              <!-- Useful link block starts  -->
              <div class="rightPanelSubHead" v-if="responseObject.usefulLinks" >Useful Links</div>
              <v-row>
                <v-col cols="12" class="pa-0" v-for="(item, index) in responseObject.usefulLinks" :key="index">
                  <v-btn
                    text
                    small
                    :href="item.link"
                    target="_blank"
                    color="#0B5940"
                    style="text-transform: none !important;"
                  >
                    {{item.legend}}
                    <v-icon class="fa" x-small aria-hidden="true"
                    >mdi-open-in-new</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Useful link block ends  -->
            <!-- Mobile County and Postalcode section starts -->
              <div>
                <div
                v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaCountyList !== 'undefined'"
                class="rightPanelSubHead" >Counties</div>
                <v-row no-gutters>
                  <v-col
                    v-for="(item, n) in responseObject.metaCountyList"
                    :key="n"
                    cols="6"
                    sm="6"
                    lg="6"
                    md="6"
                  >
                    <v-card
                      v-if="(n+1)%2 === 0"
                      outlined
                      class="ml-6 mt-3 rightPanelCntText"
                      @click="goToCountyPage(responseObject.stateName, item.name)"
                    >
                      {{ item.name }}
                    </v-card>
                    <v-card
                      v-else
                      outlined
                      class="mt-3 rightPanelCntText"
                      @click="goToCountyPage(responseObject.stateName, item.name)"
                    >
                      {{ item.name }}
                    </v-card>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>
                <!-- State Abbr block start -->
                <div class="rightPanelSubHead" v-if="responseObject.adoptionLevel === '1'" >State Abbreviation</div>
                <v-row v-if="responseObject.adoptionLevel === '1'" no-gutters>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-card
                      outlined
                      class="mt-3 rightPanelCntText2"
                    >
                      {{ responseObject.stateAbbr }}
                    </v-card>
                  </v-col>
                </v-row>
                <!-- State Abbr block end -->
                <!-- Postal code block start -->
                <div
                v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 0"
                class="rightPanelSubHead" >Postal Codes</div>
                <div v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 0" id="rpcSection" class="postalBlockHide" >
                  <v-row no-gutters>
                    <v-col
                      v-for="(item, n) in responseObject.metaPostalList"
                      :key="n"
                      cols="3"
                      sm="3"
                      lg="3"
                      md="3"
                    >
                      <v-card
                        v-if="(n+1)%4 === 0"
                        outlined
                        class="mr-1 mt-3 rightPanelPostalText"
                      >
                        {{ item.postalCode }}
                      </v-card>
                      <v-card
                        v-else
                        outlined
                        class="mr-2 mt-3 rightPanelPostalText"
                      >
                        {{ item.postalCode }}
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <p
                v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 28"
                class="mt-2" id="togglePostalText" @click="togglePostalBlock(!rpcSectionVal)" >Show More <span class="showLess"></span></p>
                <!-- Postal code block end -->
              </div>
              <!-- Join email section starts mobile -->
              <JoinEmailList />
              <!-- Join email section mobile ends -->
              <!-- Mobile County and Postalcode section ends -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Mobile version end -->
      <!-- ND desktop starts -->
      <v-row style="background-color:#f1f1f1" class="ml-sm-0 mr-sm-0 pb-8 mb-4">
      <!-- ND Left column start -->
        <v-col
          class="only-sm-and-up d-none d-sm-block pr-7 pl-2 pt-2"
          :cols="12"
          :sm="4"
          :md="4"
          :lg="4"
          :xl="4"
        >
        <back-button class="mb-4" :navigatedFrom="`Home`"></back-button>
          <v-flex v-if="!$vuetify.breakpoint.smAndDown" class="text-left txt-black mt-4">
            Result for code adoptions in
          </v-flex>
          <v-row no-gutter >
            <v-col :cols="12" class="py-1 my-0" v-if="!$vuetify.breakpoint.smAndDown">
              <Breadcrumb
                :key="$route.fullPath"
                @defaultAdoptionItems="defaultAdoptionItems = $event"
                @dataLoader="dataLoader = $event"
              ></Breadcrumb>
            </v-col>
          </v-row>
          <v-row v-if="dataLoader">
            <v-col
              v-for="(n, key) in 1"
              :key="key"
              lg="6"
              md="4"
              sm="12"
              cols="12"
              class="pt-4 pb-0"
            >
              <v-skeleton-loader
                type="list-item-avatar-three-line"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <!-- State seal and details start  -->
          <v-row no-gutters v-else-if="responseObject.entitySeal" class="mt-1" >
            <v-col cols="2" class="pa-0 d-flex justify-center align-center mr-2" >
              <v-img
                :src="
              responseObject.entitySeal !== undefined &&
              responseObject.entitySeal
                ? responseObject.entitySeal
                : ''
            "
                style="max-width:56px"
                class="img-width img-print"
              />
            </v-col>
            <v-col cols="9">
              <div class="textHeadStateWrapper">
                {{ responseObject.entityName ? responseObject.entityName : "" }}
              </div>
              <div class="font18 mt-2" v-if="responseObject.adoptionLevel === '1'" >
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else-if="responseObject.adoptionLevel === '4'" >
                {{ responseObject.countyName }},
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else >
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
            </v-col>
            <v-col class='py-2' cols="12">
              <v-row no-gutters>
                <v-col class="pa-0 ma-0" cols="12" sm="12">
                  <p class="mb-0 text-left" v-if="(responseObject.jurisdictionUrl && responseObject.jurisdictionUrl !== null)">
                    <v-btn color="primary" x-small @click="onClickCodeOffice">
                      <span v-if="responseObject.adoptionLevel === '1'" >State Information and Resources</span>
                      <span v-else >Code Office</span>
                      <v-icon class="fa" x-small aria-hidden="true">mdi-open-in-new</v-icon>
                    </v-btn>
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-1" v-else >
            <v-col cols="12">
              <div class="textHeadStateWrapper">
                {{ responseObject.entityName ? responseObject.entityName : "" }}
              </div>
              <div class="font18 mt-2" v-if="responseObject.adoptionLevel === '1'" >
                {{ responseObject.countryAbbr }}
              </div>
              <div class="font18 mt-2" v-else-if="responseObject.adoptionLevel === '4'" >
                {{ responseObject.countyName }},
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
              <div v-else class="font18 mt-2" >
                {{ responseObject.stateName }},
                {{ responseObject.countryAbbr }}
              </div>
            </v-col>
            <v-col cols="12" class='pb-2 pt-0'>
              <v-row no-gutters>
                <v-col class="pa-0 ma-0" cols="12" sm="12">
                  <p class="mb-0 text-left" v-if="(responseObject.jurisdictionUrl && responseObject.jurisdictionUrl !== null)">
                    <v-btn color="primary" x-small style="color:white" @click="onClickCodeOffice">
                      <span v-if="responseObject.adoptionLevel === '1'" >State Information and Resources</span>
                      <span v-else >Code Office</span>
                      <v-icon class="fa" x-small aria-hidden="true">mdi-open-in-new</v-icon>
                    </v-btn>
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="7" lg="7" md="12" sm="12" class="mt-1 pa-0"
              v-if="responseObject.jurisdictionProfile && responseObject.jurisdictionProfile !== 'NA'"
            >
              <span class="fontsizeForJurisdictionProfile">
                {{ responseObject.jurisdictionProfile }}
              </span>
            </v-col>
            <v-col
              v-if="responseObject.jurisdictionProfile && responseObject.jurisdictionProfile !== 'NA'"
              cols="5" lg="5" md="12" sm="12" class="print-hide pa-0 mt-1">
              <p class="mb-0" v-if="(responseObject.amendmentUrl && responseObject.amendmentUrl !== null && responseObject.amendmentUrl !== 'NA')">
                <v-btn
                  color="primary"
                  x-small
                  style="color:white"
                  @click="onClickAmendmentUrl"
                >
                  AMENDMENT URL
                  <v-icon class="fa" x-small aria-hidden="true"
                  >mdi-open-in-new</v-icon
                  >
                </v-btn>
              </p>
            </v-col>
            <v-col v-else cols="12" lg="12" sm="12" md="12" class="print-hide">
              <p class="mb-0 text-right" v-if="(responseObject.amendmentUrl && responseObject.amendmentUrl !== null && responseObject.amendmentUrl !== 'NA')">
                <v-btn
                  color="primary"
                  x-small
                  style="color:white"
                  @click="onClickAmendmentUrl"
                >
                  AMENDMENT URL
                  <v-icon class="fa" x-small aria-hidden="true"
                  >mdi-open-in-new</v-icon>
                </v-btn>
              </p>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <!-- State seal and details ends -->
          <CodeAdoptionMap  v-if="responseObject.timeStamp && !isMobile" :key="responseObject.timeStamp" />
          <v-spacer></v-spacer>
          <!-- Useful link block starts  -->
          <div class="rightPanelSubHead" v-if="responseObject.usefulLinks" >Useful Links</div>
          <v-row>
            <v-col class="pa-0" cols="12" v-for="(item, index) in responseObject.usefulLinks" :key="index">
              <v-btn
                text
                small
                :href="item.link"
                target="_blank"
                color="#0B5940"
                style="text-transform: none !important;"
              >
                {{item.legend}}
                <v-icon class="fa" x-small aria-hidden="true"
                >mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <!-- Useful link block ends  -->
          <!-- County and Postalcode section starts -->
          <v-spacer></v-spacer>
          <div>
            <div
              v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaCountyList !== 'undefined'"
              class="rightPanelSubHead" >Counties</div>
            <v-row no-gutters>
              <v-col
                v-for="(item, n) in responseObject.metaCountyList"
                :key="n"
                cols="12"
                sm="6"
                lg="6"
                md="12"
              >
                <v-card
                  v-if="(n+1)%2 === 0"
                  outlined
                  class="ml-6 mt-3 rightPanelCntText"
                  @click="goToCountyPage(responseObject.stateName, item.name)"
                >
                  {{ item.name }}
                </v-card>
                <v-card
                  v-else
                  outlined
                  class="mt-3 rightPanelCntText"
                  @click="goToCountyPage(responseObject.stateName, item.name)"
                >
                  {{ item.name }}
                </v-card>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <!-- State Abbr block start -->
            <div class="rightPanelSubHead" v-if="responseObject.adoptionLevel === '1'" >State Abbreviation</div>
            <v-row v-if="responseObject.adoptionLevel === '1'" no-gutters>
              <v-col
                cols="12"
                sm="12"
              >
                <v-card
                  outlined
                  class="mt-3 rightPanelCntText2"
                >
                  {{ responseObject.stateAbbr }}
                </v-card>
              </v-col>
            </v-row>
            <!-- State Abbr block end -->
            <!-- Postal code block start -->
            <div
              v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 0"
              class="rightPanelSubHead" >Postal Codes</div>
            <div v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 0" id="rpcSection" class="postalBlockHide" >
              <v-row no-gutters>
                <v-col
                  v-for="(item, n) in responseObject.metaPostalList"
                  :key="n"
                  cols="12"
                  sm="3"
                  lg="3"
                  md="3"
                >
                  <v-card
                    v-if="(n+1)%4 === 0"
                    outlined
                    class="mr-1 mt-3 rightPanelPostalText"
                  >
                    {{ item.postalCode }}
                  </v-card>
                  <v-card
                    v-else
                    outlined
                    class="mr-2 mt-3 rightPanelPostalText"
                  >
                    {{ item.postalCode }}
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <p
              v-if="(responseObject.adoptionLevel === '3' || responseObject.adoptionLevel === '4') && typeof responseObject.metaPostalList !== 'undefined' && responseObject.metaPostalList.length > 28"
              class="mt-2" id="togglePostalText" @click="togglePostalBlock(!rpcSectionVal)" >Show More <span class="showLess"></span></p>
            <!-- Postal code block end -->
          </div>
          <!-- County and Postalcode section ends -->
          <!-- Join email section starts -->
          <JoinEmailList />
          <!-- Join email section ends -->
        </v-col>
      <!-- ND left column end -->
      <!-- ND Right column start -->
        <v-col class="pa-1 ma-0" :sm="8" :md="8" :lg="8" :xl="8" >
          <!-- ND adoption current/past starts -->
          <div class="text-right" >
            <span class="green-txt caption text-uppercase ml-1 font-weight-medium" >Adoption</span>
            <v-btn id="currentActive" color="#0B5940" text small @click="switchAdoption('current')" >Current</v-btn>
            <span class="green-txt body-2" >|</span>
            <v-btn id="pastActive" color="#0B5940" text small @click="switchAdoption('past')" >Past</v-btn>
          </div>
          <v-spacer></v-spacer>
          <!-- ND adoption current/past ends -->
          <!-- ND additional description starts -->
          <v-row no-gutters v-if="responseObject.adoptionDescription !== '' && responseObject.adoptionDescription !== null && responseObject.adoptionDescription !== undefined" >
            <v-col>
              {{ responseObject.adoptionDescription }}
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <!-- ND additional description ends -->
          <!-- ND searched items listing -->
          <v-row no-gutters  >
            <v-col class="pa-0 ma-0" :cols="12">
              <v-row no-gutters v-if="dataLoader">
                <v-col
                  v-for="(n, key) in 6"
                  :key="key"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="py-0 pr-1 mt-4"
                >
                  <v-skeleton-loader
                    class="mx-auto"
                    type="list-item-avatar-three-line"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
              <!-- from adopt listing start -->
              <div v-else >
                <v-row no-gutters v-if="(typeof getBookList !== 'undefined' && getBookList.length > 0)" >
                  <v-col v-for="(item) in getBookList" :key="item.id" lg="4" md="4" sm="12" cols="12" class="pa-1 ma-0 for-print-change adopListCls">
                    <v-card style="background-color: inherit" height="92%" flat >
                      <v-row class="mb-4" no-gutters >
                        <v-col cols="4" lg="4" md="4" class="pt-0 pb-0" >
                          <v-img
                            v-if="item.customCodeBookLogo !== ''"
                            :src="item.customCodeBookLogo"
                            contain
                            class="img-print"
                          />
                          <v-img
                            v-else
                            :src="item.codeBookLogo"
                            contain
                            class="img-print"
                          />
                        </v-col>
                        <v-col cols="8" class="bookTitle pt-0 pb-0 pl-2 pr-0 ma-0">
                          <v-card style="background-color: inherit;" class="d-flex flex-column align-start text-left" height="100%" >
                            <span v-if="item.customTitleYear">{{ item.customTitleYear }}</span>
                            <span v-else >{{ item.bookTitleYear }}</span>
                            <div v-if="item.effectiveDate" class="caption font-weight-light">
                              Effective Date: {{item.effectiveDate}}
                            </div>
                            <!-- display adoption descriptor -->
                            <div v-for="(lst, key) in item.adoptionDescriptor" :key="key" class="adopDescrpText font-italic font-weight-normal">
                              {{ lst }}
                            </div>
                            <v-layout justify-start align-end class="mt-2 cartContentIcons">
                              <v-btn
                                elevation="0"
                                x-small
                                color="warning"
                                dark class="print-hide mr-2"
                                style="border-radius: 0px !important;"
                                v-if="item.customTitleContentUrl"
                                @click="onClickNewWindow(item.customTitleContentUrl)" >
                                <v-icon x-small color="white" >mdi-open-in-new</v-icon>
                              </v-btn>
                              <v-btn
                                elevation="0"
                                x-small
                                color="warning"
                                dark class="print-hide mr-2"
                                style="border-radius: 0px !important;"
                                v-else-if="item.codeBookContentUrl"
                                @click="onClickNewWindow(item.codeBookContentUrl)" >
                                <v-icon x-small color="white" >mdi-open-in-new</v-icon>
                              </v-btn>
                              <v-btn
                                elevation="0"
                                v-if="item.customTitleUrl"
                                x-small
                                color="primary"
                                dark
                                class="print-hide"
                                style="border-radius: 0px !important;"
                                @click="onClickNewWindow(item.customTitleUrl)" >
                                <v-icon class="fa" x-small >mdi-cart</v-icon>
                              </v-btn>
                              <v-btn
                                elevation="0"
                                v-else-if="item.codeBookUrl"
                                x-small
                                color="primary"
                                dark
                                class="print-hide"
                                style="border-radius: 0px !important;"
                                @click="onClickNewWindow(item.codeBookUrl)" >
                                <v-icon class="fa" x-small >mdi-cart</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <template v-else>
                  <p class="text-left subtitle-1 no-adoption-text" v-if="responseObject.adoptionLevel === '4'">{{ NO_DATA_FOUND }}{{this.selectedLocation + ',  ' + responseObject.countyName + ',  ' + responseObject.stateName}}<span v-html="NO_DATA_FOUND_PART_II" ></span><br />
                    <span v-html="NO_ADOPTION_TEXT"></span>
                  </p>
                  <p class="text-left subtitle-1 no-adoption-text" v-else-if="responseObject.adoptionLevel === '2' || responseObject.adoptionLevel === '3'">{{ NO_DATA_FOUND }}{{this.selectedLocation + ',  ' + responseObject.stateName}}<span v-html="NO_DATA_FOUND_PART_II" ></span><br />
                    <span v-html="NO_ADOPTION_TEXT"></span>
                  </p>
                  <p class="text-left subtitle-1 no-adoption-text" v-else>{{ NO_DATA_FOUND }}{{this.selectedLocation}}<span v-html="NO_DATA_FOUND_PART_II" ></span><br />
                    <span v-html="NO_ADOPTION_TEXT"></span>
                  </p>
                </template>
              </div>
              <!-- from adopt listing end -->
            </v-col>
          </v-row>
          <!-- ND adoption listing ends-->
        </v-col>
      <!-- ND Right column end -->
      </v-row>
      <div class="my-2">
        <p class="disclaimer-text" v-html="DISCLAIMER_TEXT"></p>
      </div>
      <!-- ND desktop ends -->
      <!-- Left column start -->
      <!-- Desktop version -->
    </v-col>
    <!-- Left column ends -->
    <!-- Right column start -->
    <!-- Right column ends -->
    <!-- </v-row> -->
    <div id="noPrintNote">
      <h2 class="pt-10" style="font-size: 34px;">This page is intended to be viewed online only and may not be printed.</h2>
    </div>
  </v-container>
</template>
<script>
import Breadcrumb from '../breadcrumb/Breadcrumb'
// import AdoptionItemsList from '../adoptionitemslist/AdoptionItemsList'
import CodeAdoptionMap from '../countrymap/CodeAdoptionMap'
import CONSTANTS from '../../../config/constant'
import Geolocationmarker from './../search/Geolocationmarker'
import JoinEmailList from './../joinemaillist/JoinEmailList'
import BackButton from '../layout/BackButton.vue'

export default {
  name: 'CodeAdoption',
  components: {
    Breadcrumb,
    // AdoptionItemsList,
    CodeAdoptionMap,
    Geolocationmarker,
    JoinEmailList,
    'back-button': BackButton
  },
  data: () => ({
    seen: true,
    searchBar: true,
    mapShow: true,
    ifNotJurisdictionURL: true,
    dataLoader: false,
    isMobile: false,
    mobileMapLoader: false,
    defaultAdoptionItems: 'Current',
    // from adoptlist start
    adpListWidth: 6,
    NO_DATA_FOUND: 'No code adoption found for the selected ',
    NO_DATA_FOUND_PART_II: CONSTANTS.NO_DATA_FOUND_PART_II,
    DISCLAIMER_TEXT: CONSTANTS.DISCLAIMER_TEXT,
    NO_ADOPTION_TEXT: CONSTANTS.NO_ADOPTION_TEXT,
    selectedLocation: '',
    // from adoptlist end
    rpcSectionVal: true
  }),
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  watch: {
    $route (to, from) {
      this.seen = true
    }
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    document.getElementById('currentActive').style.textDecoration = 'underline'
    document.getElementById('currentActive').style.fontWeight = '900'
    this.$globalFromValidation.forceTabActive(this.$route.name)
  },
  computed: {
    // searchCnt () {
    //   return (this.$vuetify.breakpoint.width <= 600) ? '' : 'pl-0 pr-0 pt-0 ml-0 mr-2'
    // },
    searchInpCnt () {
      return (this.$vuetify.breakpoint.width <= 600) ? 'd-sm-block test pa-0 ma-0' : 'mb-2 order-2 order-md-4 d-sm-block'
    },
    boxshadow_white () {
      return (this.$vuetify.breakpoint.width <= 600) ? '' : 'boxshadow-white'
    },
    // from adoptlist start
    getColWidth () {
      let adpListWidth = 6
      if (this.$vuetify.breakpoint.width < 600) {
        adpListWidth = 12
      }
      return adpListWidth
    },
    /* getBookList () {
      return this.$store.getters['FESearchModule/fetchAdvanceSearchList']
    }, */
    // from adoptlist end
    getColWidthForResultWrapper () {
      let adpListWrapperWidth = 8
      if (this.$vuetify.breakpoint.width < 600) {
        adpListWrapperWidth = 12
      }
      return adpListWrapperWidth
    },
    getBookList () {
      return this.$store.getters['FESearchModule/fetchAdvanceSearchList']
    },
    getJurisdictionUrl () {
      return this.jurisdictionUrl
    },
    getAmendmentUrl () {
      return this.amendmentUrl
    },
    getJurisdictionProfile () {
      return this.jurisdictionProfile
    },
    getMapZoomSetting () {
      return this.$store.getters['FEMapModule/fetchMapZoomSettings']
    },
    getMapAbbrivationResult () {
      return this.$store.getters['FEMapModule/fetchMapAbbrivationResult']
    },
    shouldBookMarkApiCall () {
      return this.$store.getters['FESearchModule/fetchCheckBookMarkSearchAPI']
    },
    responseObject () {
      return this.$store.getters['FEMapModule/fetchMetaData']
    }
  },
  updated () {
    if (this.shouldBookMarkApiCall) {
      this.$store.commit('FESearchModule/setCheckBookMarkSearchAPI', false)
    }
    let url = location.pathname
    let array = url.split('/')
    this.selectedLocation = array.slice(-1)[0].replace(/-/g, ' ')
  },
  methods: {
    nativeDownload () {
      window.print()
    },
    goToCountyPage (sN, cN) {
      let stateName = sN !== '' ? sN.replace(/\s+/g, '-') : ''
      let countyName = cN !== '' ? cN.replace(/\s+/g, '-') : ''
      if (countyName !== '' && countyName !== '') {
        this.$router.push({ name: 'CountyCodeAdoption', params: { stateName: stateName, countyName: countyName } })
      }
    },
    togglePostalBlock (toggleFlag) {
      this.rpcSectionVal = toggleFlag
      if (!toggleFlag) {
        document.getElementById('togglePostalText').innerHTML = 'Show Less <span class="showMore"></span>'
        document.getElementById('rpcSection').classList.remove('postalBlockHide')
        document.getElementById('rpcSection').classList.add('postalBlockShow')
      } else {
        document.getElementById('togglePostalText').innerHTML = 'Show More <span class="showLess"></span>'
        document.getElementById('rpcSection').classList.remove('postalBlockShow')
        document.getElementById('rpcSection').classList.add('postalBlockHide')
      }
    },
    onClickCodeOffice () {
      window.open(this.responseObject.jurisdictionUrl)
    },
    onClickAmendmentUrl () {
      window.open(this.responseObject.amendmentUrl)
    },
    onResize () {
      this.isMobile = window.innerWidth < 600
    },
    switchAdoption (adopType) {
      this.defaultAdoptionItems = adopType.charAt(0).toUpperCase() + adopType.slice(1)
      if (this.defaultAdoptionItems.toLowerCase() === 'current') {
        document.getElementById('currentActive').style.textDecoration = 'underline'
        document.getElementById('currentActive').style.fontWeight = '900'
        document.getElementById('pastActive').style.textDecoration = 'none'
        document.getElementById('pastActive').style.fontWeight = 'normal'
      }
      if (this.defaultAdoptionItems.toLowerCase() === 'past') {
        document.getElementById('currentActive').style.textDecoration = 'none'
        document.getElementById('currentActive').style.fontWeight = 'normal'
        document.getElementById('pastActive').style.textDecoration = 'underline'
        document.getElementById('pastActive').style.fontWeight = '900'
      }
      const formData = this.generateFromData(adopType)
      this.dataLoader = true
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
      }).then((tokenData) => {
        let tokens = tokenData.data
        this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
          new Promise((resolve, reject) => {
            this.$store.dispatch('FESearchModule/fetchBooksOnLoad', {
              resolve,
              reject,
              formData
            })
          })
            .then(responseData => {
              // Call bookmark
              this.dataLoader = false
            })
            .catch(response => {
              this.dataLoader = false
            })
        }).catch()
      }).catch()
    },
    generateFromData (adopType = 'Current') {
      return {
        jurisdictionName: typeof this.$route.params.jurisdictionName !== 'undefined' ? this.$route.params.jurisdictionName.replace(/-/g, ' ').toLowerCase() : '',
        stateName: typeof this.$route.params.stateName !== 'undefined' ? this.$route.params.stateName.replace(/-/g, ' ').toLowerCase() : '',
        countyName: typeof this.$route.params.countyName !== 'undefined' ? this.$route.params.countyName.replace(/-/g, ' ').toLowerCase() : '',
        townshipName: typeof this.$route.params.townshipName !== 'undefined' ? this.$route.params.townshipName.replace(/-/g, ' ').toLowerCase() : '',
        status: adopType.toLowerCase()
      }
    },
    showHideMap () {
      this.mapShow = !this.mapShow
      this.mobileMapLoader = (this.mapShow === false) ? !this.mapShow : false
    },
    onClickNewWindow (url) {
      if (url !== '') {
        window.open(url, '_blank')
      }
    }
  }
}
</script>
